import { createSlice } from "@reduxjs/toolkit";
import { getDriverRegionSales } from "./driverRegionSalesAction";

const initialState = {
  loading: false,
  error: null,
  success: false,
  drivers: [],
  latestRequestId: null,
};

const driverRegionSalesSlice = createSlice({
  name: "driverRegionSales",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDriverRegionSales.pending, (state, action) => {
        state.loading = true;
        state.drivers = [];
        state.error = null;
        state.latestRequestId = action.meta.requestId;
      })
      .addCase(getDriverRegionSales.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.drivers = action.payload;
        state.error = null;
      })
      .addCase(getDriverRegionSales.rejected, (state, action) => {
        if (action.meta.requestId !== state.latestRequestId) return;
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default driverRegionSalesSlice.reducer;
